import { useMutation } from '@tanstack/react-query';
import {
  claimAllMilestones,
  claimRbeMilestoneReward,
} from '@wwe-portal/web/services/client/rbe';
import { useInvalidateUserProgress } from './rbe';

export const useClaimSoloEventMilestoneReward = () => {
  const invalidateUserSoloProgress = useInvalidateUserProgress();
  return useMutation({
    mutationFn: claimRbeMilestoneReward,
    onSuccess: () => {
      invalidateUserSoloProgress();
    },
  });
};

export const useClaimAllRewards = () => {
  const invalidateUserProgress = useInvalidateUserProgress();
  return useMutation({
    mutationFn: claimAllMilestones,
    onSuccess: () => {
      invalidateUserProgress();
    },
  });
};
